import { render, staticRenderFns } from "./sourceGroup.vue?vue&type=template&id=f713a67a&scoped=true&"
import script from "./sourceGroup.vue?vue&type=script&lang=js&"
export * from "./sourceGroup.vue?vue&type=script&lang=js&"
import style0 from "./sourceGroup.vue?vue&type=style&index=0&id=f713a67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f713a67a",
  null
  
)

export default component.exports